export const graphPreviewStyles = [
  {
    selector: "node.preview-muted",
    style: {
      "opacity": 0.35,
      "text-opacity": 1,
      "background-opacity": 0.45
    }
  },
  {
    selector: "edge.preview-muted",
    style: {
      "opacity": 0.12,
      "text-opacity": 0
    }
  },
  {
    selector: "node.preview-focus",
    style: {
      "opacity": 1,
      "border-width": "4px",
      "border-color": "#1976D2",
      "z-index": "900"
    }
  },
  {
    selector: "edge.preview-focus",
    style: {
      "opacity": 0.95,
      "line-color": "#1E88E5",
      "target-arrow-color": "#1E88E5",
      "width": 3,
      "z-index": "850"
    }
  },
  {
    selector: "node.filtered",
    style: {
      "display": "none"
    }
  },
  {
    selector: "edge.filtered",
    style: {
      "display": "none"
    }
  },
];
